module.exports = __webpack_public_path__ + "media/customizations/mygcplife/logo-2eee75b546b0ecac66804cd82f7872be.png";